const headers = {
  name: "Services",
  navigate: {
    tabs: [
      {
        name: "Services",
        path: "/app/services",
      },
      {
        name: "Add",
        path: "",
      },
    ],
  },
};

export default headers;